import { useMutation, useQueryClient } from '@tanstack/react-query';
import { roomAdApi } from '../api/roomAd.api';
import { roomAdKeys } from '../api/roomAd.keys';
import toast from 'react-hot-toast';

export function useCreateRoomAd() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => roomAdApi.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: roomAdKeys.all });
      toast.success('Room ad created');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to create room ad');
    },
  });
}

export function useUpdateRoomAd() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => roomAdApi.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: roomAdKeys.all });
      toast.success('Room ad updated');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to update room ad');
    },
  });
}

export function useDeleteRoomAd() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => roomAdApi.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: roomAdKeys.all });
      toast.success('Room ad deleted');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to delete room ad');
    },
  });
}
